import { pasosDataLayer } from "../constants/pasosDataLayer";
import { valuesExtProducto } from "../constants/valuesExtProducto";
import { existeId } from "./existeId";

export function observerDatalayer() {
  window.dataLayerTari = true;
  let lastComponentStep = "";
  let paso = "";
  let lastIndexDatalayerAdeslas = 0;

  const observer = new MutationObserver((mutationList, observer) => {
    if (typeof dataLayer != "undefined") {
      let lastIndexDatalayer = 0;

      dataLayer.find(function (value, index) {
        if (
          typeof value != "undefined" &&
          Object.hasOwnProperty.call(pasosDataLayer, value.event)
        ) {
          lastIndexDatalayer = index;
        }
      });

      if (lastIndexDatalayer != lastIndexDatalayerAdeslas) {
        paso = dataLayer[lastIndexDatalayer].event;

        dataLayerAdeslas.paso_tarificador = paso;
        lastIndexDatalayerAdeslas = lastIndexDatalayer;

        for (const datoPaso in pasosDataLayer[paso]) {
          if (
            Object.hasOwnProperty.call(dataLayer[lastIndexDatalayer], datoPaso)
          ) {
            if (datoPaso == "Asegurado") {
              dataLayerAdeslas["firstname"] =
                dataLayer[lastIndexDatalayer]["Asegurado"][0].firstname || "";
              dataLayerAdeslas["Lastname"] =
                dataLayer[lastIndexDatalayer]["Asegurado"][0].Lastname || "";
              dataLayerAdeslas["Fecha_de_nacimiento"] =
                dataLayer[lastIndexDatalayer]["Asegurado"][0]
                  .Fecha_de_nacimiento || "";
              dataLayerAdeslas["phone"] =
                dataLayer[lastIndexDatalayer]["Asegurado"][0].telefono || "";
              dataLayerAdeslas["postalCode"] =
                dataLayer[lastIndexDatalayer]["Asegurado"][0].postalCode || "";

              if (
                dataLayer[lastIndexDatalayer]["Asegurado"][0].Sexo !=
                  undefined &&
                !existeId(DFI.labels.EExternals, 1424)
              ) {
                DFI.labels.EExternals.push({
                  id: 1424,
                  option:
                    dataLayer[lastIndexDatalayer]["Asegurado"][0].Sexo ==
                    "Hombre"
                      ? 1
                      : 2,
                });
              }

              dataLayerAdeslas["Otro_seguro_salud_1"] =
                dataLayer[lastIndexDatalayer]["Asegurado"][0]
                  .Otro_seguro_salud || "";
            } else {
              if (datoPaso == "componentStep") {
                lastComponentStep = dataLayer[lastIndexDatalayer][datoPaso];
                dataLayerAdeslas["componentStep"] =
                  dataLayer[lastIndexDatalayer][datoPaso];
              } else if (datoPaso == "ProductType") {
                dataLayerAdeslas["tipoproducto"] =
                  dataLayer[lastIndexDatalayer][datoPaso];
              } else if (datoPaso == "id_presupuesto") {
                dataLayerAdeslas["Presupuesto"] =
                  dataLayer[lastIndexDatalayer][datoPaso];
              } else if (datoPaso == "product_name") {
                let producto = dataLayer[lastIndexDatalayer][datoPaso];

                if (producto != "" && !existeId(DFI.labels.EExternals, 1010)) {
                  producto = producto.trim().toUpperCase();

                  DFI.labels.EExternals.push({
                    id: 1010,
                    option: valuesExtProducto[producto],
                  });
                }
              } else if (datoPaso == "num_asegurados") {
                DFI.labels.ESales = JSON.stringify([
                  [
                    {
                      id: 3,
                      value: dataLayer[lastIndexDatalayer]["num_asegurados"],
                    },
                  ],
                ]);
              } else {
                dataLayerAdeslas[datoPaso] =
                  dataLayer[lastIndexDatalayer][datoPaso];
              }
            }
          }
        }

        if (
          typeof dataLayerAdeslas["phone"] != "undefined" &&
          dataLayerAdeslas["phone"] != ""
        ) {
          if (DFI.labels.EExternals.length > 0) {
            dataLayerAdeslas.EExternals = JSON.stringify(DFI.labels.EExternals);
          }
          if (
            typeof DFI.labels.ESales != "undefined" &&
            DFI.labels.ESales.length > 0
          ) {
            dataLayerAdeslas.ESales = JSON.stringify(DFI.labels.ESales);
          }

          // cambiamos pasos (WCS-33539)
          //dataLayerAdeslas.paso_tarificador = nuevos_pasos[dataLayerAdeslas.paso_tarificador];

          if (
            dataLayerAdeslas.componentStep == "Telefono" &&
            dataLayerAdeslas.paso_tarificador ==
              "tarifier_step3_contact_details"
          ) {
            dataLayerAdeslas.verifyLeadId = "NO";

            DFI.addLead(dataLayerAdeslas, function (resp) {
              console.log("addlead", resp);
            });
          } else {
            dataLayerAdeslas.verifyLeadId = "SI";

            Object.keys(dataLayerAdeslas).forEach(function (i) {
              if (i != "EExternals") {
                DFI.labels.EDeclaratives[i] = dataLayerAdeslas[i];
              }
            });

            if (typeof DFI.getCookie("wIdlLead") != "undefined") {
              DAL.Ajax({
                type: "jsonp",
                url: "https://ws.walmeric.com/provision/wsclient/delioClientLeadId_put.html",
                data: {
                  idTag:
                    "29842f94d414949bf95fb2e6109142cfef1fb2a78114c2c536a36bf5a65b953aae636090917c003002e97758b0e81efa029559b1bae7df3a45536d5c36fc2f567a0ca4a14c080dbe7f601cea7019a16610968c55948828aa9c72bebdbb63b34980fa3d1e48c3fad33ab38aa009fca5ab",
                  leadId: DFI.getCookie("wIdlLead"),
                  data: JSON.stringify(DFI.labels),
                },
              }).done(function (resp) {
                console.log("updatelead con put", resp);
              });
            } else {
              DFI.addLead(dataLayerAdeslas, function (resp) {
                console.log("updatelead con add", resp);
              });
            }
          }
        }
      }
    }
  });

  let target = document.querySelector(".main-content-wrapper");
  observer.observe(target, { subtree: true, childList: true });
}
